// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientAddresseRow_root__3iEP9"};